import { PerspectiveCamera } from '@react-three/drei';
import { Canvas, extend } from '@react-three/fiber';
import * as THREE from 'three';
import type { MockItem } from '../../types';
import { ThreeJSSceneContent } from '../ThreeJSSceneContent';

type _Props = {
  activeMocks: string[];
  height?: string;
  mocks: Record<string, MockItem>;
  onSelectMock: (id: string) => void;
};

const ThreeJSScene = ({ activeMocks, height = '400px', mocks, onSelectMock }: _Props) => {
  // Extend Three.js elements for JSX
  extend({ PointLight: THREE.PointLight, AmbientLight: THREE.AmbientLight });

  return (
    <div style={{ width: '100%', height, position: 'relative' }}>
      <Canvas>
        <PerspectiveCamera makeDefault position={[0, 0, 6]} />
        <ThreeJSSceneContent activeMocks={activeMocks} mocks={mocks} onSelectMock={onSelectMock} />
      </Canvas>
    </div>
  );
};

export default ThreeJSScene;
